import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'sortByDestination'
})
export class SortByDestinationPipe implements PipeTransform {
  transform(itinerary: any, itemsArray: any, datePipe: DatePipe): any {
    const _array: any = [];
    // Primero procesamos los destinos
    itinerary.destination.forEach(destination => {
      _array.push({
        city: destination.destination_info.cityName ? destination.destination_info.cityName : destination.iata_code,
        arrival: new Date(destination.destination_info.arrival), // Guardamos como Date para ordenar
        formattedArrival: datePipe.transform(destination.destination_info.arrival, 'MMM dd, yyyy'),
        departure: new Date(destination.destination_info.departure), // Guardamos como Date para ordenar
        formattedDeparture: datePipe.transform(destination.destination_info.departure, 'MMM dd, yyyy'),
        iata: destination.iata_code,
        items: []
      });
    });

    // Asignamos items a cada destino
    _array.forEach(destination => {
      const dest = destination.items;
      itemsArray.forEach(item => {
        let itemDestination = (item.item.destination) ? item.item.destination.iata_code : item.item.payloadUpdate.products[0].destination;
        if (destination.iata === itemDestination) {
          dest.push(item);
        }
      });
    });

    // Filtramos destinos sin items
    const filteredArray = _array.filter(destination => destination.items.length > 0);

    // Ordenamos por fecha arrival (de menor a mayor)
    filteredArray.sort((a, b) => {
      return a.arrival.getTime() - b.arrival.getTime();
    });

    // Convertimos las fechas Date a formato string para la vista
    return filteredArray.map(destination => {
      return {
        ...destination,
        arrival: destination.formattedArrival,
        departure: destination.formattedDeparture
      };
    });
  }
}
